import { useEffect } from 'react';
import { EnvelopeSlash } from 'react-bootstrap-icons';

import { Button, Typography } from 'antd';

import EmptyState from '@/components/shared/EmptyState';
import InfiniteScroll from '@/components/shared/InfiniteScroll';
import { inviteApi, useAcceptAllInvitesMutation } from '@/services/invites';
import styled, { css, StyledProp } from '@/styled';

import Item from './Item';

const TabInvites = (props: StyledProp) => {
  const [fetch, { data, isFetching }] = inviteApi.endpoints.fetchAllInvitesData.useLazyQuery();
  const [markAll, markAllResponse] = useAcceptAllInvitesMutation();

  useEffect(() => {
    fetch({ page: 1 });
  }, [fetch]);

  const fetchNewPage = () => {
    if (!data?.page || isFetching) return;
    if (data?.page?.page >= data?.total_pages) return;

    fetch({ ...data?.page, page: data?.page?.page + 1 });
  };

  if ((data?.data ?? []).length === 0 && !isFetching) {
    return (
      <div className={props.className}>
        <EmptyState
          className='emptyState'
          icon={<EnvelopeSlash size={64} />}
          description=''
          title='Você não possui convites'
        />
      </div>
    );
  }

  return (
    <div className={props.className}>
      <div className='updatesHeader'>
        <Typography.Text></Typography.Text>
        <Button ghost loading={markAllResponse.isLoading}>
          <Typography.Text onClick={() => markAll()}>Aceitar todos</Typography.Text>
        </Button>
      </div>
      <InfiniteScroll className='list' onReachedEnd={fetchNewPage}>
        {data?.data.map(item => (
          <Item {...item} key={item.id} />
        ))}
        <div data-show={data?.total_pages === data?.page?.page} className='loading'>
          <Typography.Text>Carregando</Typography.Text>
        </div>
      </InfiniteScroll>
    </div>
  );
};

export default styled(TabInvites)(
  ({ theme }) => css`
    width: 100%;

    .emptyState {
      padding: ${theme.space.pxToRem(40)};
    }

    button {
      padding: 0;
      border: 0;
    }

    .list {
      max-height: 300px;

      .loading {
        .ant-typography {
          display: block;
        }
        margin: 0 auto;
        height: 32px;
        width: fit-content;
        &[data-show='true'] {
          display: none;
        }
      }
    }

    .updatesHeader {
      padding: ${theme.space.spacing(3, 6)};
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .ant-typography {
        color: ${theme.colorTextTertiary};
        font-size: ${theme.space.pxToRem(12)};
      }
    }
  `
);
